<template>
  <div>
    <div class="all-column" v-if="model.length > 0">
      <div v-for="(list, index) in model" :key="index">
        <div v-if="!disabled">
          <i class="fas fa-download mr10 pointer" @click="downloadFile(list.path)"></i>
          {{ list.original_name }}
        </div>
        <div class="btn btn-default btn-file" v-else @click="downloadFile(list.path)">
          <i class="fas fa-download mr10"></i> {{ list.original_name }}
        </div>
      </div>
    </div>
    <div v-else>
      - Tidak ada file
    </div>
    <label class="btn btn-default btn-file" v-if="!disabled">
      <i class="fas fa-upload mr10"></i>
      <input type="file" style="display: none;" @change="fileChangeHandler($event)" />
      <span class="all-column">Upload</span>
    </label>
    <!-- <label class="btn btn-default btn-file" v-else>
      <i class="fas fa-download mr10"></i>
      <span class="all-column">{{
        $get(
          $store,
          `state.${storeName}.${modelName}.original_name`,
          'Download'
        )
      }}</span>
    </label> -->
  </div>
</template>
<script>
import axios from 'axios'
import { api_lp } from '../../../services/config'
export default {
  props: ['modelName', 'storeName', 'mutationName', 'disabled', 'docId'],
  computed: {
    model: {
      get() {
        return this.$store.state[this.storeName][this.modelName]
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: newValue,
        })
      },
    },
  },
  methods: {
    fileChangeHandler(e) {
      let fileUpload = Array.from(e.target.files)
      let fileType = fileUpload[0].type
      let fileName = fileUpload[0].name

      fileUpload['file'] = fileUpload
      fileUpload['fileName'] = fileUpload[0].name

      if (
        fileType.search(/jpeg|jpg|pdf|xls|zip|rar/gi) >= 0 ||
        fileName.search(/.rar/gi) >= 0
      ) {
        this.uploadFile(fileUpload[0])
      } else {
        alert(`Jenis File ${fileType} tidak dapat di upload`)
      }
    },
    async uploadFile(file) {
      try {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        const url = `${api_lp}/api/v1/vendor/k3l-dokument-multiple`

        let bodyFormData = new FormData()
        bodyFormData.append(
          'request_id',
          this.$store['state'][this.storeName]['request_id']
        )
        bodyFormData.append('m_k3l_doc_id', this.docId)
        bodyFormData.append('k3l_document_lampiran[]', file)

        const { data } = await axios({
          method: 'POST',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (data.status == 'success') {
          this.$store.commit(this.mutationName, {
            name: this.modelName,
            value: [],
          })
          this.$store.commit(this.mutationName, {
            name: this.modelName,
            value: data.data,
          })
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
    async downloadFile(link) {
      if (link) {
        let linkUrl = `${api_lp}/k3l-file/${link}`
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        await axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(async response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
          .catch(async error => {
            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
      }
    },
    async deleteFile(id, request_id, m_id) {
      try {
        const url = `${api_lp}/api/v1/vendor/k3l-dokument/${id}/${request_id}/${m_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        if (data && data.status == 'success') {
          this.$store.commit(this.mutationName, {
            name: this.modelName,
            value: data.data,
          })
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: multiple_upload.vue ~ line 151 ~ deleteFile ~ error',
          error
        )
      }
    },
  },
}
</script>
